import crypto from 'crypto';
import React from 'react';
import { withApollo } from "react-apollo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter, Redirect } from 'react-router-dom';

import { getPayload } from '../../util';
import { loginOld, migrateUser } from '../../graphql/mutations';


class Migrate extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			step: 1,
			id: '',
			token: '',
			name: '',
			avatar: '',
			email: '',
			birthday: '',
			oldpass: '',
			newpass: ''
		};

		this.loginOld = this.loginOld.bind(this);
    	this.migrateCredentials = this.migrateCredentials.bind(this);
    	this.updateProfile = this.updateProfile.bind(this);
	}

	loginOld() {

		if(this.state.name.trim() === '') {
			alert("Pls supply username.")
			return;
		}
		if(this.state.oldpass.trim() === '') {
			alert("Pls supply password.")
			return;
		}

		const md5hash = crypto.createHash('md5').update(this.state.oldpass).digest('hex');

		const qlVars = {
			name: this.state.name,
			password: md5hash
		};

		this.props.client.mutate({
			mutation: loginOld,
			variables: qlVars
		})
		.then(res => {
			if(res.data.loginOld) {
				const payload = getPayload(res.data.loginOld);
				const { id, name, avatar, phone, email, description } = payload;

				this.setState({
					token: res.data.loginOld,
					step: 2,
					id: id,
					name: name ? name : '',
					avatar: avatar ? avatar : '',
					phone: phone ? phone : '',
					email: email ? email : '',
					description: description ? description : ''
				});
			}
		})
		.catch(e => {
			alert('LoginOld Error: ' + e);
		});
	}

	migrateCredentials() {
		if(this.state.name.length < 3) { alert("Pls supply username with at least 3 chararacters."); return; }
		if(this.state.newpass.length < 6) { alert('Pls supply password with at least 6 chararacters.'); return; }
		this.setState({step: 3});
	}

	updateProfile() {

		const { id, token, name, phone, email, description, birthday, newpass } = this.state;

		this.props.client.mutate({
			mutation: migrateUser,
			variables: { id, token, name, phone, email, description, birthday, password: newpass }
		})
		.then(res => {
			if(res.data.migrateUser) {
				this.setState({
					step: 4
				});
			}
		})
		.catch(e => {
			alert('Migrate Error: ' + e);
		});
	}


	render() {
		const step = this.state.step;
		if(step === 1) {
			return this.renderStep1();
		} else if(step === 2) {
			return this.renderStep2();
		} else if(step === 3) {
			return this.renderStep3();
		} else if(step === 4) {
			return this.renderStep4();
		} else {
			return (<Redirect to="/" />)
		}
	}


	renderStep1() {
		return (
			<div className="fullHeight">
				<div className="container">
					<div className="login centered">
						
						<div className="richtext dist-1" style={{textAlign: 'center'}}>
							<p>
								Um einen bestehenden Account in das neue System zu übertragen, gib bitte hier deine alten Zugangsdaten ein:
							</p>
							<p style={{textAlign: 'center'}}>
								<FontAwesomeIcon className="fa-key" icon="american-sign-language-interpreting" style={{fontSize:"6rem"}}/>
							</p>
						</div>

						<form onSubmit={(e) => e.preventDefault() }>
							<input className="input" onChange={e => this.setState({ name: e.target.value })} type="text" placeholder="username" />
							<input className="input" onChange={e => this.setState({ oldpass: e.target.value })} type="password" placeholder="password" />
							
							<div className="button-wrap">
								<a className="button button--secondary" href="/">&lt; login</a>
								<button onClick={this.loginOld} className="button button--submit">next</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
	
	renderStep2() {

		return (
			<div className="fullHeight">
				<div className="container">
					<div className="login centered">

						<div className="richtext dist-1" style={{textAlign: 'center'}}>
							<div className="avatar" style={{backgroundImage: `url(/avatare/${this.state.avatar})`, display: 'inline-block'}} />
							<p className="p">Welcome back, {this.state.name}!</p>
							<p>Da im neuen System modernere Verschlüsselungen durchgeführt werden, brauchen wir ein neues Passwort von dir.</p>
							<p>Außerdem hast du die einmalige Gelegenheit, deinen Namen zu ändern :o</p>
						</div>
						
						<p style={{textAlign: 'center'}}>
							<FontAwesomeIcon className="fa-key" icon="diagnoses" style={{fontSize:"6rem"}}/>
						</p>
						
						<form onSubmit={(e) => e.preventDefault() }>
							<input className="input" type="text" placeholder="username" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
							<input className="input" type="password" placeholder="new password" value={this.state.newpass} onChange={e => this.setState({ newpass: e.target.value })} />
							
							<div className="button-wrap">
								<a className="button button--secondary" target="_blank" rel="noopener noreferrer" href="http://random-ize.com/how-long-to-hack-pass/">how long to hack my password?</a>
								<button onClick={this.migrateCredentials} className="button button--submit">next</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}

	renderStep3() {
		return  (
			<div className="fullHeight">
				<div className="container">
					<div className="login centered">

						<div className="richtext dist-1">
							<div style={{textAlign: 'center'}}>
								<p>
									Du kannst folgende Daten hinterlegen, um sie mit Gruppenmitgliedern zu teilen:
								</p>
								<p style={{textAlign: 'center'}} className="p">{this.state.name}</p>
								<div className="avatar" style={{backgroundImage: `url(/avatare/${this.state.avatar})`, display: 'inline-block'}} />
							</div>
						</div>
						
						<form onSubmit={(e) => e.preventDefault() }>
							<label className="label" htmlFor="phone">Fon</label>
							<input id="phone" className="input" type="text" placeholder="+49 144 844 3444" value={this.state.phone} onChange={e => this.setState({phone: e.target.value})} />
							
							<label className="label" htmlFor="email">E-Mail</label>
							<input id="email" className="input" type="email" placeholder="user@example.net" value={this.state.email} onChange={e => this.setState({email: e.target.value})} />
							
							<label className="label" htmlFor="birthday">Geburtstag</label>
							<input id="birthday" className="input" type="date" placeholder="date" value={this.state.birthday} onChange={e => this.setState({birthday: e.target.value})} />


							<p className="dist-1">
								Alle Angaben sind optional.
							</p>
							<p className="dist-1">
								Durch Absenden stimmst du zu, dass dieser Dienst im Sinne seines Zweckes personenbezogene Daten erhebt und verarbeitet. 
							</p>
							
							<div className="button-wrap">
								<button onClick={this.updateProfile} className="button button--submit">migrate account</button>
							</div>
						</form>		
					</div>
				</div>
			</div>)
	}



	renderStep4() {
		return  (
			<div className="fullHeight">
				<div className="container">
					<div className="login centered">

						<div className="richtext dist-1">
							<div style={{textAlign: 'center'}}>
								<p>
									Dein Profil wurde erfolgreich übertragen!
								</p>
								<p style={{textAlign: 'center'}} className="p">{this.state.name}</p>
								<div className="avatar" style={{backgroundImage: `url(/avatare/${this.state.avatar})`, display: 'inline-block'}} />
							</div>
						</div>

						<div className="richtext">
							<p> 
								Im Moment ist vieles noch buggy und unvollständig. Bitte hab noch etwas Geduld, bis das neue System das alte übertreffen wird!
							</p>
							<p>
								<a className="button" href="/login">Zum Login</a>
							</p>
						</div>
					</div>
				</div>
			</div>)
	}
}

export default withRouter(withApollo(Migrate))


// WEBPACK FOOTER //
// ./src/components/user/Migrate.js